module.exports = __webpack_public_path__ + "img/ico-soldout.39a8f482.svg";